// Auto generated file, do not manually modify!
// com.hotpads.maintenancetracker.web.users.lessen.handler.MaintenanceTrackerLessenWaitlistWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  MaintenanceTrackerLessenWaitlistWebApiHandler_join,
  MaintenanceTrackerLessenWaitlistWebApiHandler_status,
  MaintenanceTrackerLessenWaitlistWebApiHandler_status_Path,
} from '@zg-rentals/ts-maintenance-tracker-client';

import type { LessenWaitlistStatusResponseDto } from '@zg-rentals/ts-maintenance-tracker-client';

export type MaintenanceTrackerLessenWaitlistWebApiHandler_join_Options = UseMutationOptions<
  LessenWaitlistStatusResponseDto,
  unknown,
  void
>;

/**
 * Join the Lessen waitlist
 */
export const useMaintenanceTrackerLessenWaitlistWebApiHandler_join = ({
  httpClient,
  ...options
}: Omit<MaintenanceTrackerLessenWaitlistWebApiHandler_join_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: () => MaintenanceTrackerLessenWaitlistWebApiHandler_join(httpClient),
  });
};

export type MaintenanceTrackerLessenWaitlistWebApiHandler_status_Options = UseQueryOptions<
  LessenWaitlistStatusResponseDto,
  unknown,
  LessenWaitlistStatusResponseDto,
  readonly [string]
>;

const MaintenanceTrackerLessenWaitlistWebApiHandler_status_GetKey = () =>
  [MaintenanceTrackerLessenWaitlistWebApiHandler_status_Path] as const;

export const MaintenanceTrackerLessenWaitlistWebApiHandler_status_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: MaintenanceTrackerLessenWaitlistWebApiHandler_status_GetKey(),
    queryFn: () => MaintenanceTrackerLessenWaitlistWebApiHandler_status(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get the user's Lessen waitlist status
 */
export const useMaintenanceTrackerLessenWaitlistWebApiHandler_status = ({
  httpClient,
  ...options
}: Omit<MaintenanceTrackerLessenWaitlistWebApiHandler_status_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...MaintenanceTrackerLessenWaitlistWebApiHandler_status_queryOptions({ httpClient }),
    ...options,
  });
};
useMaintenanceTrackerLessenWaitlistWebApiHandler_status.getKey =
  MaintenanceTrackerLessenWaitlistWebApiHandler_status_GetKey;
